import axios from 'axios';
import { put, all, takeLatest } from 'redux-saga/effects';

import moment from 'moment';
import { DATE_TIME_FORMAT } from 'app/types/constants';
import {
  biSiteVisitsByDateFailure,
  biSiteVisitsByDateRequest,
  biSiteVisitsByDateSuccess,
  biSiteVisitsBySiteAndDateFailure,
  biSiteVisitsBySiteAndDateRequest,
  biSiteVisitsBySiteAndDateSuccess,
  biSiteVisitsFailure,
  biSiteVisitsRequest,
  biSiteVisitsSuccess,
  setLoadingState,
} from './actions';
import { STATISTICS } from 'app/api-routes';

function* biSiteVisitsSaga({ payload: { month, year, siteID, supervisorID, mobilePatrolID, clientID } }) {
  const startDate = moment(`${year}-${month}`).startOf('month').format(DATE_TIME_FORMAT);
  const endDate = moment(`${year}-${month}`).endOf('month').format(DATE_TIME_FORMAT);
  const params = { startDate, endDate, timeZoneOffset: moment().utcOffset() };

  if (siteID) {
    params.siteID = siteID;
  }

  if (supervisorID) {
    params.supervisorID = supervisorID;
  }

  if (mobilePatrolID) {
    params.mobilePatrolID = mobilePatrolID;
  }

  if (clientID) {
    params.clientID = clientID;
  }

  try {
    const { payload, warnings } = yield axios.get(`${STATISTICS}/site-visits`, {
      params,
    });
    yield put(biSiteVisitsSuccess(payload, { warnings }));
  } catch (err) {
    yield put(biSiteVisitsFailure(err));
  }
}

function* biSiteVisitsByDateSaga({
  payload: { month, year, siteID, mobilePatrolID, clientID, supervisorID },
}) {
  const startDate = moment(`${year}-${month}`).startOf('month').format(DATE_TIME_FORMAT);
  const endDate = moment(`${year}-${month}`).endOf('month').format(DATE_TIME_FORMAT);

  const params = {
    startDate,
    endDate,
    timeZoneOffset: moment().utcOffset(),
  };

  if (siteID) {
    params.siteID = siteID;
  }

  if (supervisorID) {
    params.supervisorID = supervisorID;
  }

  if (mobilePatrolID) {
    params.mobilePatrolID = mobilePatrolID;
  }

  if (clientID) {
    params.clientID = clientID;
  }

  try {
    yield put(setLoadingState(true));

    const { payload, warnings } = yield axios.get(`${STATISTICS}/site-visits/grouped-by-date`, { params });
    yield put(biSiteVisitsByDateSuccess(payload, { warnings }));
  } catch (err) {
    yield put(biSiteVisitsByDateFailure(err));
  } finally {
    yield put(setLoadingState(false));
  }
}

function* biSiteVisitsBySiteAndDateSaga({
  payload: { month, year, siteID, supervisorID, mobilePatrolID, clientID },
}) {
  const startDate = moment(`${year}-${month}`).startOf('month').format(DATE_TIME_FORMAT);
  const endDate = moment(`${year}-${month}`).endOf('month').format(DATE_TIME_FORMAT);

  const params = { startDate, endDate, timeZoneOffset: moment().utcOffset() };

  if (siteID) {
    params.siteID = siteID;
  }

  if (supervisorID) {
    params.supervisorID = supervisorID;
  }

  if (mobilePatrolID) {
    params.mobilePatrolID = mobilePatrolID;
  }

  if (clientID) {
    params.clientID = clientID;
  }

  try {
    const { payload, warnings } = yield axios.get(`${STATISTICS}/site-visits/grouped-by-site-and-date`, {
      params,
    });
    yield put(biSiteVisitsBySiteAndDateSuccess(payload, { warnings }));
  } catch (err) {
    yield put(biSiteVisitsBySiteAndDateFailure(err));
  }
}

export default function* () {
  yield all([
    takeLatest(biSiteVisitsRequest, biSiteVisitsSaga),
    takeLatest(biSiteVisitsBySiteAndDateRequest, biSiteVisitsBySiteAndDateSaga),
    takeLatest(biSiteVisitsByDateRequest, biSiteVisitsByDateSaga),
  ]);
}
